import request from '@/utils/request';
import { Session, Local } from '@/utils/storage';
import { ElMessageBox } from 'element-plus';

export interface ExeParams {
  cobject: string,
  coperation: string,
  objparameter: any
}
export interface LoginParams {
  cfed: string,
  caccount: string,
  cpassword: string,
  clang: string
}
export interface UserParams {
  iduser: string
}
//事务执行
export async function execute(params: ExeParams): Promise<any> {
  const response = await request({
    url: '/transapi/execute',
    method: 'post',
    data: params
  });
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}

export async function login(params: LoginParams): Promise<any> {
  return request({
    url: '/authapi/login',
    method: 'post',
    data: params
  });
}
export async function logout(params: UserParams): Promise<any> {
  return request({
    url: '/authapi/logout',
    method: 'post',
    data: params
  });
}
export async function token(params: LoginParams): Promise<any> {
  const response = await request({
    url: '/authapi/token',
    method: 'post',
    data: params
  });
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}
//导航菜单
export async function getmenu(params: UserParams): Promise<any> {
  const response = await request({
    url: '/authapi/getmenu2',
    method: 'post',
    data: params
  });
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}

//上传文件
export async function uploadFile(params: ExeParams) {
  const response = await request({
    url: 'fileapi/upload',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}
//上传多文件
export async function uploadFiles(params: ExeParams) {
  const response = await request({
    url: 'fileapi/mutiupload',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}
//excel导入
export async function impExcel(params: ExeParams) {
  const response = await request({
    url: 'fileapi/impexcel',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}

export async function getsrv(params: LoginParams): Promise<any> {
  const response = await request({
    url: '/authapi/getsrv',
    method: 'post',
    data: params
  });
  if (response.iresult == 777) {
    ElMessageBox.confirm(`${response.cerror}。是否重新登录？`, '提醒', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      Session.clear();
      window.location.reload();
      const para = {} as any;
      logout(para);
    });
    return;
  }
  return response;
}